import { BoosterType } from '../../Card/BoosterType';
import CardStateHelper from '../../Card/CardStateHelper';
import { ContextType } from '../ContextType';
import { GameScene } from '../GameScene';
import GameStateHelper from '../GameStateHelper';
import { IGameState } from '../IGameState';
import { canShowInterstitialAd } from '../../Level/LevelStateHelper';
import { ProgressStateHelper } from '../../Player/Progress/ProgressStateHelper';
import { PopupID } from '../../UI/PopupID';
import UIStateHelper from '../../UI/UIStateHelper';
import ContextStateHelper from '../Context/ContextStateHelper';
import { AdvertisementArea, AdvertisementType, IAdvertisementPayload } from 'Utility/SDK/Advertisement';
import { ConditionalTrackingHelper } from 'Utility/Tracking/TrackingHelpers/ConditionalTracking';
import { HeavyUsersTracking } from 'Utility/Tracking/TrackingHelpers/HeavyUsersTracking';
import { FBTrackingEvent } from 'Utility/Tracking/FBTrackingEvent';
import { RewardType } from 'Utility/Rewards/RewardType';
import { track, TrackMethod } from 'Utility/Tracking/Track';
import { InfoMenuType } from 'System/UI/Menu/InfoMenuHandler';
import { AdsConfig } from 'Constants/Ads';
import Game from 'Game';
import { FieldStateHelper } from 'State/Player/Fields/FieldStateHelper';
import { AD_SPACES_WITHOUT_COUNTER_INCREMENT } from 'Constants/Ads';
import { QuestStateHelper } from 'State/Player/Quests/QuestStateHelper';
import { trackResourceEvent } from 'Utility/Tracking/TrackingHelpers/Transaction';
import { TActionType, TransactionType } from 'Utility/Tracking/DataSet/Transaction';

export default class AdsStateHelper {
    public static checkDisplayInterstitial(state: IGameState): IGameState {
        if (canShowInterstitialAd(state)) {
            return ContextStateHelper.setContext(state, ContextType.DISPLAY_ADVERTISEMENT, {
                placement: AdsConfig.getInterstitialDefault(Game.config),
                payload: {
                    g_gameArea: AdvertisementArea.LEVEL_COMPLETE,
                    levelNumber: state.levelState.levelNumber,
                    levelType: state.levelState.levelType,
                },
            });
        }

        return state;
    }

    public static adComplete(currentState: IGameState, payload: IAdvertisementPayload): IGameState {
        let state = currentState;
        state = ProgressStateHelper.increaseTotalAdsWatched(currentState);
        HeavyUsersTracking.trackHeavyUserAdsIfNeeded(state.playerState);
        state = ConditionalTrackingHelper.trackConditionally(state, [
            FBTrackingEvent.AD_10_3DAYS,
            FBTrackingEvent.AD_20_5DAYS,
            FBTrackingEvent.AD_30_7DAYS,
        ]);

        if (payload.placement.type === AdvertisementType.INTERSTITIAL) {
            return AdsStateHelper.handleInterstitial(state, payload);
        } else if (payload.g_gameArea === AdvertisementArea.CHANGE_MISSION) {
            return AdsStateHelper.handleGetNewQuest(state, payload);
        }

        if (!payload.reward) return state;

        if (AD_SPACES_WITHOUT_COUNTER_INCREMENT.indexOf(payload.g_gameArea) === -1) {
            state = ProgressStateHelper.setAdsWatched(state, state.playerState.progress.adsWatched + 1);
        }

        switch (payload.reward.type) {
            case RewardType.PLUS_FIVE_CARDS:
                state = CardStateHelper.playBooster(state, BoosterType.PLUS_FIVE, {});
                break;
            case RewardType.COINS:
                if (state.activeScene.result === GameScene.LEVEL) {
                    track('mCoinsBoughtWithAds', payload.reward.value, TrackMethod.ADD);
                }
                track('tAdCoins', payload.reward.value, TrackMethod.ADD);

                if (!payload.skipPopup) {
                    state = {
                        ...state,
                        UIState: UIStateHelper.showPopup(state.UIState, PopupID.INFO_MENU, {
                            type: InfoMenuType.COIN_REWARD,
                            reward: payload.reward,
                        }),
                    };
                }

                if (payload.g_gameArea === AdvertisementArea.DOUBLE_HARVEST) {
                    state = FieldStateHelper.harvest(state, {
                        forceRewardAmount: payload.reward.value,
                        playAutoFlow: payload.playAutoFlow,
                    });
                }
                else {
                    trackResourceEvent(state, {
                        transactionType: TransactionType.AD,
                        tActionType: TActionType.AD,
                    });
                }
                break;
            case RewardType.FREE_PLAY:
                state = GameStateHelper.loadLevel(state, {
                    preBoosters: payload.levelPayload.preBoosters,
                    levelNumber: payload.levelPayload.levelNumber,
                    levelCost: 0,
                });
                break;
        }

        /*
        trackResourceEvent(state, {
            transactionType: TransactionType.AD,
            tActionType: TActionType.AD,
        });
        */

        return state;
    }

    public static handleInterstitial(state: IGameState, payload: IAdvertisementPayload) {
        return state;
    }
    public static handleGetNewQuest(state: IGameState, payload: IAdvertisementPayload) {
        return QuestStateHelper.refreshQuestAfterCooldown(state, payload.questIndex);
    }
}
